import axios from 'axios';
import jwt_decode from 'jwt-decode';

export default class AuthService {
  constructor() {
    this.apiUrl = process.env.VUE_APP_API_BASE;
  }

  getToken() {
    return localStorage.getItem('accessToken');
  }

  getDecoded() {
    try {
      return jwt_decode(this.getToken())
    } catch (err) {
      return null;
    }
  }

  isLogged() {
    const decoded = this.getDecoded();

    return typeof decoded === 'object' && decoded !== null;
  }

  logoff() {
    localStorage.removeItem('accessToken');
  }

  authenticate(email, password) {
    return axios
      .post(`${this.apiUrl}/login`, {
        email,
        password
      })
  }
}
